module.exports = __webpack_public_path__ + "static/shop_logo-07b152b29f5141130911aad8129502a2.png";